import React from 'react';
import { arrayOf, shape, string, func, object, bool } from 'prop-types';
import { theme } from '@magalu/stereo-ui-styles';
import { Icon } from '@magalu/stereo-ui-icons';
import { MAGALU_DOMAIN } from '../../constants';
import { Wrapper, Container, BreadcrumbList } from './breadcrumb.styles';
import JsonLD, { breadcrumbSchema } from '../../atoms/JsonLD';
import { BreadcrumbItem } from '../../atoms';
export function isActive(count, index) {
  if (index === 1) return false;
  return count === index;
}

const Breadcrumb = ({
  isTransparent,
  items,
  seller,
  onLogoClick,
  onClickItem,
  domain,
  logo
}) => {
  const {
    url = '/',
    icon = 'LogoMagalu',
    title = 'página inicial magalu',
    styles = {
      color: theme.colors.blue,
      height: '14px',
      marginTop: '6px',
      width: '60px'
    }
  } = logo || {};
  const firstItem = {
    url,
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: icon,
      style: styles
    }),
    title
  };
  firstItem.handleClick = onLogoClick;
  items.forEach(item => Object.assign(item, {
    handleClick: onClickItem
  }));
  const breadcrumbItems = [!seller && firstItem, ...items];
  return /*#__PURE__*/React.createElement(Wrapper, {
    isTransparent: isTransparent
  }, /*#__PURE__*/React.createElement(Container, {
    isTransparent: isTransparent
  }, /*#__PURE__*/React.createElement(BreadcrumbList, null, seller && /*#__PURE__*/React.createElement(BreadcrumbItem, {
    seller: seller
  }), !seller && breadcrumbItems.map((item, index) => /*#__PURE__*/React.createElement(BreadcrumbItem, {
    "data-testid": "breadcrumb-item",
    key: index,
    item: Object.assign({}, item, {
      position: index
    }),
    active: isActive(items.length, index),
    onClick: item.handleClick
  })))), /*#__PURE__*/React.createElement(JsonLD, {
    schema: breadcrumbSchema(items, domain),
    type: "BreadcrumbList"
  }));
};

Breadcrumb.defaultProps = {
  isTransparent: false,
  items: [],
  seller: undefined,
  onClickItem: () => {},
  onLogoClick: () => {},
  domain: MAGALU_DOMAIN
};
process.env.NODE_ENV !== "production" ? Breadcrumb.propTypes = {
  items: arrayOf(shape({
    url: string,
    name: string.isRequired,
    icon: string
  })),
  onClickItem: func,
  onLogoClick: func,
  seller: shape({
    name: string.isRequired
  }),
  domain: string.isRequired,
  logo: shape({
    url: string.isRequired,
    icon: string.isRequired,
    title: string.isRequired,
    styles: object
  }),
  isTransparent: bool
} : void 0;
export default Breadcrumb;